import { FormControlLabel, FormHelperText, Switch } from '@mui/material'
import { CustomVariable, CustomVariableValue } from '@/types/custom-variables'

type PONumbersMustMatchSwitchProps = {
  variable: CustomVariable
  value?: CustomVariableValue
  ownerOrgId: string
  onValueChange: (
    variableValue: Omit<CustomVariableValue, 'id' | 'project_id'> & {
      id?: string
    },
  ) => void
}

/**
 * Project-wide switch for the `z-global_po_numbers_must_match` setting. When on,
 * PO matching only considers POs whose number matches the invoice's PO number.
 */
export default function PONumbersMustMatchSwitch({
  variable,
  value,
  ownerOrgId,
  onValueChange,
}: PONumbersMustMatchSwitchProps) {
  // Off unless explicitly turned on, the same default pd-po applies
  const isPONumberMatchRequired = value?.value === 'true'

  return (
    <div>
      <FormControlLabel
        control={
          <Switch
            checked={isPONumberMatchRequired}
            onChange={(_e, checked) => {
              onValueChange({
                ...value,
                custom_variable_id: variable.id,
                owner_org_id: ownerOrgId,
                value: checked ? 'true' : 'false',
              })
            }}
          />
        }
        label="PO Numbers Must Match"
      />
      {variable.description && (
        <FormHelperText>{variable.description}</FormHelperText>
      )}
    </div>
  )
}
